import { useEffect } from "react";
import { GADataProps } from "@components/GAData/GAData";

type UseSetGaDataProps = {
  /** The initial GA data props from the server side. */
  initialGaProps?: GADataProps;
  /** The GA data props to be set in the client side. */
  gaProps?: GADataProps;
};

/**
 * Custom hook to set the GA data for the page in client side.
 */
export const useSetGaData = ({
  initialGaProps,
  gaProps,
}: UseSetGaDataProps) => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    window._data = {
      ...initialGaProps,
      ...gaProps,
    };
  }, [gaProps, initialGaProps]);
};
